import { ModelBase } from '../../core/model/model-base';
import { LocalDate } from '../../core/model/local-date';
import { PropertyPostTarget } from '../../rent/model/property';
import { BuildingPostTarget } from '../../rent/model/building';
import { DwellingPostTarget } from '../../rent/model/dwelling';
import { PremisesPostTarget } from '../../rent/model/premises';
import { ParkingPostTarget } from '../../rent/model/parking';
import { EntrancePostTarget } from '../../rent/model/entrance';
import { OtherRentalObjectPostTarget } from '../../rent/model/other-rental-object';
import { CompanyPostTarget } from '../../rent/model/company';

export class Post extends ModelBase {
  constructor() {
    super();

    Object.defineProperties(this, {
      _publishedFrom: { enumerable: false, writable: true },
      _publishedTo: { enumerable: false, writable: true },
    });
  }

  private _publishFrom: LocalDate;
  private _publishTo: LocalDate;

  content: string;
  get publishFrom(): LocalDate {
    return this._publishFrom;
  }
  set publishFrom(value: LocalDate) {
    this._publishFrom = LocalDate.fromDate(value);
  }
  get publishTo(): LocalDate {
    return this._publishTo;
  }
  set publishTo(value: LocalDate) {
    this._publishTo = LocalDate.fromDate(value);
  }
  sortOrder: number;
  title: string;
  postTargets: PostTarget[];

  toJSON() {
    const json = Object.assign({}, this);
    json.publishFrom = this.publishFrom;
    json.publishTo = this.publishTo;
    return json;
  }
}

export class PostTarget {
  constructor(init?: Partial<PostTarget>) {
    Object.assign(this, init);
    this.company = init?.company ? new CompanyPostTarget(init.company) : null;
    this.property = init?.property ? new PropertyPostTarget(init.property) : null;
    this.building = init?.building ? new BuildingPostTarget(init.building) : null;
    this.dwelling = init?.dwelling ? new DwellingPostTarget(init.dwelling) : null;
    this.premises = init?.premises ? new PremisesPostTarget(init.premises) : null;
    this.parking = init?.parking ? new ParkingPostTarget(init.parking) : null;
    this.otherRentalObject = init?.otherRentalObject ? new OtherRentalObjectPostTarget(init.otherRentalObject) : null;
    this.entrance = init?.entrance ? new EntrancePostTarget(init.entrance) : null;
  }

  id?: string;
  company: CompanyPostTarget;
  property: PropertyPostTarget;
  building: BuildingPostTarget;
  dwelling: DwellingPostTarget;
  premises: PremisesPostTarget;
  parking: ParkingPostTarget;
  entrance: EntrancePostTarget;
  otherRentalObject: OtherRentalObjectPostTarget;
  childScope: PostTargetChildScope | null;
}

export enum PostTargetChildScope {
  Full = 0,
  Company = 1,
  Property = 2,
  Building = 3,
  Parking = 4,
  OtherRentalObject = 5,
  Dwelling = 6,
  Premises = 7,
  Entrance = 8,
}
